const Footer = () => {
    return (
      <footer className="bg-white py-4 border-t w-screen fixed bottom-0 overflow-hidden z-50">
        <div className="w-full mx-auto  text-center text-sm text-gray font-sans">
          <p>
            Copyright © {new Date().getFullYear()} , Poverty Alleviation and Inclusive Development Across Rural Sindh (PAIDAR). All rights reserved.
          </p>
        </div>
      </footer>
    );
  };
  
  export default Footer;
  